import { changeCustomerSelectCustomerContainerStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { css } from "styled-components";

changeCustomerSelectCustomerContainerStyles.billToSelector = {
    billToSelectorDynamicDropdown : {
        cssOverrides : {
            dropdownWrapper : css`
                ul {
                    overflow: auto;
                    max-height: 250px;
                }
            `,
        }
    }
};

changeCustomerSelectCustomerContainerStyles.shipToSelector = {
    shipToSelectorDynamicDropdown : {
        cssOverrides : {
            dropdownWrapper : css`
                ul {
                    overflow: auto;
                    max-height: 250px;
                }
            `,
        }
    }
};